import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import { LiveRateContainer, StaticRateContent, RateIndicator, StaticRateValue } from './styled';
import { StatusDot } from '@dealstack/frontend/app/pages/Valuations/views/EditValuation/FXRatesDrawer/styled';
import { formatNumber } from '@dealstack/shared/lib/format/number';
import { memo } from 'react';
import { useTranslationValuations } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { VALUATION_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds';

interface Props {
	liveRate?: number;
}

const LiveRateSection = ({ liveRate }: Props) => {
	const tValuations = useTranslationValuations();

	return (
		<LiveRateContainer>
			<StaticRateContent>
				<RateIndicator>
					<StatusDot $status="live" />
					<TextV2 variant="sans/14/400">
						{tValuations('fx_drawer.live_rate_title')}
					</TextV2>
				</RateIndicator>
				<StaticRateValue>
					<TextV2
						data-testid={VALUATION_ELEMENT_ID.FX_EXCHANGE_LIVE_RATE_VALUE}
						variant="sans/14/400"
					>
						{liveRate == null
							? tValuations('fx_drawer.not_applicable_value')
							: formatNumber({
									value: liveRate,
									maxPrecision: 5,
									minPrecision: 0,
									lockPrecision: false,
								})}
					</TextV2>
				</StaticRateValue>
			</StaticRateContent>
		</LiveRateContainer>
	);
};
const _LiveRateSectionExport = memo(LiveRateSection);

export { _LiveRateSectionExport as LiveRateSection };
